export enum RealtyObjectType {
    UNKNOWN = 0,
    FLAT = 1,
    ROOM = 2,
    HOUSE = 3,
    LAND = 4,
    COUNTRY_ESTATE = 5,
}
